import React from 'react';
import Avatar from '../../atoms/Avatar/Avatar';

interface IPostAvatar {
    name: string;
    description: string;
}

const PostAvatar: React.FC<IPostAvatar> = (props) => {
    const { name, description } = props;

    return (
        <>
            <div className="relative grid w-full grid-cols-12 p-3">
                <div className="col-span-9 mr-2 text-right sm:col-span-11">
                    <div className="font-serif text-xl text-gray-900">{name}</div>
                    <div className="font-serif text-sm text-secondary">{description}</div>
                </div>

                <div className="col-span-3 flex flex-row justify-end sm:col-span-1">
                    <Avatar size="small" />
                </div>
            </div>
        </>
    );
};

export default PostAvatar;
